/*
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

export const EL_DEFAULT_ROW_LEVEL: number = 0;

export type ElDataGetter<N, T> = (N) => T;
export type ElChildrenGetter<N, T> = (N) => (T[] | undefined);
export type ElExpandedGetter<N> = (N) => boolean;

export interface ElGetters<N, T> {
    dataGetter?: ElDataGetter<N, T>;
    childrenGetter?: ElChildrenGetter<N, T>;
    expandedGetter?: ElExpandedGetter<N>;
}

/**
 * Implicit context of cells and rows
 */
export class ElTreeGridPresentationNode<T> {
    constructor(
        /**
         * Data object associated with row
         */
        public readonly data: T,
        public children: ElTreeGridPresentationNode<T>[] | undefined,
        /**
         * Row expand state
         */
        public expanded: boolean,
        public readonly level: number,
    ) { }

    /**
     * True if row has child rows
     */
    hasChildren(): boolean {
        return !!this.children && !!this.children.length;
    }
}
